import { getPublic, putPublic, put, get } from "../../data/api";

export async function stripeCall(rentalId) {
    return await getPublic('public/stripe/' + rentalId)
}
export async function paymentCall(rentalId) {
    return await getPublic('public/stripe/payment/' + rentalId)
}
export async function advancePaymentCall(rentalId) {
    return await getPublic('public/advance-payment-call/' + rentalId)
}

export async function publishableKey() {
    return await getPublic('public/publishableKey')
}

export async function stripeSuccess(payment_intent, payment_intent_client_secret) {
    return await putPublic(null, 'public/success/' + payment_intent + '/' + payment_intent_client_secret)
}
export async function stripePaymentSuccess(payment_intent, payment_intent_client_secret) {
    return await putPublic(null, 'public/payment-success/' + payment_intent + '/' + payment_intent_client_secret)
}
